<script lang="ts" setup>
const route = useRoute()
const breadcrumbRoutes = computed(() =>
  workspaceTrail(route.fullPath, route.meta.breadcrumb)
)
const category = computed(() =>
  route.path.startsWith('/setup/')
    ? setupLocation(route.path)?.group
    : undefined
)
</script>

<template>
  <nav aria-label="Breadcrumb" class="layout-breadcrumb">
    <ol>
      <template
        v-for="(breadcrumbRoute, i) in breadcrumbRoutes"
        :key="breadcrumbRoute"
      >
        <li
          class="font-medium text-surface-500 text-sm"
          :aria-current="i === breadcrumbRoutes.length - 1 ? 'page' : undefined"
        >
          <NuxtLink
            v-if="
              breadcrumbRoute === 'Setup' && i < breadcrumbRoutes.length - 1
            "
            to="/setup"
          >
            {{ breadcrumbRoute }}
          </NuxtLink>
          <NuxtLink
            v-else-if="category && breadcrumbRoute === category.label"
            :to="{ path: '/setup', query: { category: category.id } }"
          >
            {{ breadcrumbRoute }}
          </NuxtLink>
          <template v-else>{{ breadcrumbRoute }}</template>
        </li>
        <li
          v-if="i !== breadcrumbRoutes.length - 1"
          aria-hidden="true"
          class="layout-breadcrumb-chevron text-surface-500"
        >
          /
        </li>
      </template>
    </ol>
  </nav>
</template>
